import { Jaco } from "oc-jaco3d/arrangement/Jaco";
import { Jaco3d } from "oc-jaco3d/arrangement3d/Jaco3d";
import { v3 } from "oc-threejs/short3";
import { BoxGeometry, Mesh } from "three";
import { findUp } from "oc-threejs/Scenes";
import { ProfilHighlighter } from "../arrangement/ProfilHighlighter";

export class ProfilHighlighter3D extends Jaco3d {
  highlightBox: Mesh;
  declare jaco: ProfilHighlighter;
  constructor(jaco: ProfilHighlighter) {
    super(jaco);
    this.recreateBox();
    APP.on("changePositionSelectionFocus", (el, show) => this.updateVisibility(el, show));
  }

  update3d() {
    super.update3d();
    if (this.changed("highlighted")) {
      this.updateVisibility();
    }
    if (this.changed("box")) {
      this.recreateBox();
    }
  }

  updateVisibility(jaco: Jaco = null, show = false) {
    this.highlightBox.visible =
      APP.arrangement.highlightProfileActive &&
      (this.jaco.highlighted ||
        (jaco != null && show && findUp(this, (e) => (e as Jaco3d).jaco == jaco) != null));
    STAGE.dirty();
  }

  recreateBox() {
    const geo = this.getGeometry();
    if (!this.highlightBox) {
      this.highlightBox = new Mesh(geo, this.getMaterial());
      this.highlightBox.renderOrder = 999;
      this.updateVisibility();
      this.add(this.highlightBox);
    }
    this.highlightBox.geometry = geo;
  }

  getGeometry() {
    return new BoxGeometry(
      ...this.jaco
        .getSize()
        .add(v3(0, 0, 0.01))
        .toArray()
    );
  }

  getMaterial() {
    return APP.materials.create("highlightProfile");
  }
}
